<template>
	<div class="wrapper">
		<div
			class="mt-3"
			style="margin-left: 11.5rem"
			v-for="(item, index) in dataList"
			:key="index"
		>
			<div
				class="hexagon"
				:style="{
					background: 'url(' + item.photoUrl + ') center no-repeat',
					'background-size': '100%',
				}"
			></div>
			<div class="donorName">{{ item.donorName }}</div>
			<div class="enname">{{ item.rank }}</div>
			<div class="hexagon1">
				<!-- <div class="text">{{item.donorName}}</div> -->
				<div class="text" style="text-align: center; color: #999999">
					<div
						style="
							color: #bba667;
							font-weight: bold;
							height: 3.28rem;
							margin-top: 3.57rem;
							font-size: 1.28rem;
						"
					>
						{{ $t('lang.Responsibility') }}
					</div>
					<p class="p1">{{ $t('lang.oversighttho') }}</p>
					<p class="p2">{{ $t('lang.Oversighttsp') }}</p>
					<p class="Ensuretapc">{{ $t('lang.Ensuretapc') }}</p>
				</div>
			</div>
		</div>
		<!-- <div class="mt-3">
        <div class="hexagon" style="background: url('http://www.futureprize.org/resource/data/uploads/90/3471c73b0fca369888a35d5132c42e50.jpg') center no-repeat; background-size: 100%;"></div>
        <div class="hexagon1">
            <div class="text">asdas</div>
        </div>
      </div> -->
	</div>
</template>
 
<script>
export default {
	props: {
		dataList: {
			type: Array,
			default: () => [
				// {
				//     name: '获奖人',
				//     ename: 'huojiangren',
				//     type: '生命科学奖',
				//     year: 2021,
				//     donorName: 'A'
				// },
				// {
				//     name: '获奖人',
				//     ename: 'huojiangren',
				//     type: '生命科学奖',
				//     year: 2021,
				//     firstName: 'A'
				// },
				// {
				//     name: '获奖人',
				//     ename: 'huojiangren',
				//     type: '生命科学奖',
				//     year: 2021,
				//     firstName: 'A'
				// },
			],
		},
	},
	data() {
		return {}
	},
}
</script>
 
<style lang="scss" scoped>
.enname {
	font-size: 14px;
	text-align: center;
	width: 200px;
	color: #999999;
	height: 14px;
	line-height: 16px;
	margin-top: 10px;
	transform: translate(35px, 3px);
}
.wrapper {
	display: flex;
	flex-wrap: wrap;
	margin-left: -6rem;
	margin-top: 3rem;
	margin-left: -5rem;
	.hexagon1 {
		position: absolute;
		width: 20rem;
		height: 18rem;
		background: #f2f2f2;
		transform: translate(79%, -70%);
		clip-path: polygon(
			25% 0%,
			75% 0%,
			100% 50%,
			75% 100%,
			25% 100%,
			0% 50%
		);
		display: flex;
		justify-content: center;
		// align-items: center;
	}
	.hexagon {
		width: 20rem;
		height: 18rem;
		background: orange;
		/* x,y */
		clip-path: polygon(
			25% 0%,
			75% 0%,
			100% 50%,
			75% 100%,
			25% 100%,
			0% 50%
		);
	}
	p {
		margin: 0;
	}
}
.donorName {
	font-size: 18px;
	text-align: center;
	color: #666666;
	height: 18px;
	line-height: 18px;
	margin-top: 16px;
}
.Ensuretapc {
	width: 200px;
}
@media (max-width: 500px) {
	.wrapper {
		.hexagon {
			width: 15rem;
			position: relative;
			left: -15rem;
			top: 13rem;
			background: #f2f2f2;
			transform: translate(79%, -70%);
			-webkit-clip-path: polygon(
				25% 0%,
				75% 0%,
				100% 50%,
				75% 100%,
				25% 100%,
				0% 50%
			);
			clip-path: polygon(
				26% 0%,
				75% 0%,
				100% 50%,
				70% 100%,
				25% 100%,
				0% 50%
			);
			display: flex;
			justify-content: center;
		}
		.donorName {
			position: relative;
			top: -1rem;
			left: -5rem;
		}
		.hexagon1 {
			position: relative;
			top: -2rem;
			width: 16rem;
			left: -4rem;
			height: 15rem;
		}
		.enname {
			position: relative;
			top: -1rem;
			left: -7rem;
			width: 13rem;
		}
		.text {
			position: relative;
			top: -1.5rem;
		}
		.Ensuretapc[data-v-75d264a1] {
			width: 13rem;
			margin-left: 1rem;
		}
	}
}
</style>